import { Box, Typography } from "@mui/material";
import DonutChart from "./DonutChart";
import { ANALITICS_DATA } from "./constants";
import { useLazyGetMessageSummariesPerSessionQuery } from "../../../../middleware/analyticsApi";
import { useEffect, useMemo } from "react";
import { useAppSelector } from "../../../../hooks/redux";
import "./styles.css";

const Analitics = () => {
  const { falseAlarmanalyticsData } = useAppSelector((state) => state.analytics);
  const [getMessageSummariesPerSession] = useLazyGetMessageSummariesPerSessionQuery();

  useEffect(() => {
    const intervalId = setInterval(() => {
      getMessageSummariesPerSession();
    }, 1000);

    return () => {
      clearInterval(intervalId);
    };
  }, []);

  const reasonTypeColors = {
    1: "var(--redAccent)",
    2: "var(--orangeAccent)",
    3: "var(--purpleAccent)",
    4: "var(--accent)",
    5: "var(--headers)",
  };

  const donutData = useMemo(() => {
    if (!falseAlarmanalyticsData) return [];
    return (
      falseAlarmanalyticsData
        ?.filter((item) => item.fireStatus === 2)
        ?.reduce((acc, item) => {
          const existingItem = acc.find((i) => i.reasonType === item.reasonType);
          if (existingItem) {
            existingItem.count += item.count;
          } else {
            acc.push({
              reasonType: item.reasonType,
              count: item.count,
              color: reasonTypeColors[item.reasonType] || "var(--defaultColor)", // цвет по умолчанию
            });
          }
          return acc;
        }, [])
        ?.map((item) => ({
          value: item.count,
          color: item.color,
          reasonType: item.reasonType, // можно добавить для отладки
        })) || []
    );
  }, [falseAlarmanalyticsData]);

  function sumCount(id) {
    if (!falseAlarmanalyticsData?.length) return 0;
    let sum = 0;
    for (const item of falseAlarmanalyticsData) {
      if (item.reasonType === id) {
        sum += item.count;
      }
    }
    return sum;
  }

  return (
    <Box className="analitics">
      <Box className="analitics__donut-container">
        <DonutChart id="DonutChart" data={donutData} width={300} height={300} radius={260} />
      </Box>
      <Box className="analitics__content">
        {ANALITICS_DATA.map((item) => (
          <Box className="analitics__card" sx={{ justifyContent: "space-between" }} key={item.id}>
            <Box className="analitics__card">
              <img src={item.icon} alt="Иконка события" />
              <Box className="analitics__card-text">
                <Typography className="analitics__title" sx={{ color: item.color }}>
                  {item.title}
                </Typography>
                <Typography className="analitics__subtitle">{item.subtitle}</Typography>
              </Box>
            </Box>

            <Box>{sumCount(item.id)}</Box>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default Analitics;
